export default __webpack_public_path__ + "static/media/serv-01.488b4ca6.jpg";